// extracted by extract-css-chunks-webpack-plugin
module.exports = {"unread":"unread","header":"header","content":"content","chat-bubble":"chat-bubble","chat-text":"chat-text","right":"right","timestamp":"timestamp"};